import React from 'react';
import {getBooks} from '../services/Quiz';
import {IBook, IChapter} from '../model/Interfaces';
import Checkbox from "./Checkbox";
import { isNumber } from 'util';

export interface ISetup {
    book: string
    chapters: number[],
    length: number,
    mode: number
}

export interface IQuizSetupProps{
    onContinue(setup: ISetup): void
}

function QuizSetup(props:IQuizSetupProps):React.ReactElement{
    const [books,setBooks] = React.useState([] as IBook[]);
    const [chapters,setChapters] = React.useState([] as IChapter[]);
    const [selectedBook,setSelectedBook] = React.useState(-1);
    const [ready,setReady] = React.useState(false);
    const [mode,setMode] = React.useState(0);

    React.useEffect(()=>{
        getBooks().then( b => {
            setBooks(b);

            if (b.length ===1){
                setSelectedBook(0);
                setChapters(b[0].Chapters);
                setReady(false);            }
        })},[]);

    const onBookSelected = (index:number) =>{
        if (index !== selectedBook){
            setSelectedBook(index);
            setChapters(books[index].Chapters);
            setReady(false);
        }
    }

    const onModeSelected = ()=> (e:React.FormEvent<HTMLSelectElement>)=>{
        setMode(Number(e.currentTarget.value));
    }

    const onContinue = () =>{
        if (selectedBook >=0){
            const selectedChapters = [] as number[];
            let length = 0;

            chapters.forEach( c =>{
                if (c.isSelected){
                    selectedChapters.push(c.Number);
                    length += Math.ceil(c.QuestionCount * .1);
                }
            });

            if (mode == 1) { length=50} //Tournament mode

            if (length <20){
                length=20;
            } else if (length >40){
                length=40;
            }

            props.onContinue({
                book:books[selectedBook].Code,
                chapters:selectedChapters,
                length:length,
                mode:mode});
        }
        
    }

    const selectAllCheckboxes = (isSelected:boolean) => {
        const newChapters = chapters.map(c => ({...c, isSelected: isSelected}));
        setChapters(newChapters);
        setReady(isSelected);
      };
    
      const selectAll = () => selectAllCheckboxes(true);
    
      const deselectAll = () => selectAllCheckboxes(false);

      const onBoxChecked = (index:number) => (e:React.FormEvent<HTMLInputElement>) => {
        const x = [...chapters];

        x[index].isSelected = e.currentTarget.checked;

        if (e.currentTarget.checked){
            setReady(true);
        } else {
            //check if there is another chapter selected
            setReady(x.findIndex(c=>c.isSelected) >=0);
        }
        setChapters(x);
      };

    return (
        <div className='setup'>
            <div className='setup-header'>
                <h1>Quiz Settings</h1>
                <select onChange={onModeSelected()}>
                    <option value="0">Practice</option>
                    <option value="1">Tournament</option>
                </select>
            </div>
            <div className='book-list'>
                <h2>Books</h2>
                {books.map( (b,i) =>{
                    return <button key={b.Code} onClick={()=> {onBookSelected(i)}} >{b.Text}</button>
                })}
            </div>
            <div className='chapter-list'>
                <h2>Lesson</h2>
                {chapters.length > 0 &&
                <div className='chapter-buttons'>
                    <button
                    type="button"
                    className="btn btn-outline-primary mr-2"
                    onClick={selectAll}
                    >
                    Select All
                    </button>
                    <button
                    type="button"
                    className="btn btn-outline-primary mr-2"
                    onClick={deselectAll}
                    >
                    Deselect All
                    </button>
                </div>      
                }
                <div className='chapters'>
                    {chapters.map( (c,i) =>{
                        return <Checkbox key={i} label={c.Number + ') ' + c.Text} 
                            isSelected={c.isSelected == null ? false : c.isSelected} 
                            onCheckboxChange={onBoxChecked(i)}/>
                    })}
                </div>

            </div>
            <button type="button" className='continue' onClick={onContinue} disabled={!ready} >Continue</button>
        </div>
    )
}

export default QuizSetup;